import React from 'react';
import { useSelector } from 'react-redux';
import { getDepartureDate, getTripDuration } from 'Store/trip-criteria/tripCriteria.selector';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { TravelSherpa } from 'Components/widgets/travel-sherpa/TravelSherpa';
type Props = {
  id?: string;
  title: string;
};
export const TravelRestrictionsLine = ({ id, title, ...rest }: Props) => {
  const departureDate: number = useSelector(getDepartureDate);
  const duration: number = useSelector(getTripDuration);
  return (
    <SiteContainer className="Line" data-testid="travel-restrictions" id={id}>
      <LineTitle className="mb-20">{title}</LineTitle>
      <TravelSherpa {...rest} departureDate={departureDate} duration={duration} />
    </SiteContainer>
  );
};
